<template>
  <div v-show="isCuntryCookie && !isApp" :class="customClass">
    <div class="cookies-text" @click="jumpCookiePolicy">
      {{ $t('cookie-privacy.cookie_buttons.btn_policy') }}
    </div>
    <span class="line">|</span>
    <div class="cookies-text" @click="setOpenCookies(true)">
      {{ $t('cookie-privacy.cookie_buttons.btn_settings') }}
    </div>
  </div>
</template>

<script>
  import { mapMutations, mapState } from 'vuex'
  import { isMobile } from '@/utils/platform'
  import { jumpToPage } from '@/utils/utils'

  export default {
    name: 'public-footer-cookie',
    props: ['theme'],
    data() {
      return {
        isDesktop: !isMobile(),
      }
    },
    computed: {
      ...mapState(['isCuntryCookie', 'isApp', 'gameName']),
      customClass() {
        let _defaultColor = this.$route.name === 'Detail2' ? 'defaultColor' : ''
        return ['cookies-footer', this.theme, this.gameName, _defaultColor]
      },
    },
    mounted() {},
    methods: {
      ...mapMutations(['setOpenCookies']),
      jumpCookiePolicy() {
        const _location = window && window.location
        if (this.isDesktop) {
          const lastIndex = _location.pathname.lastIndexOf('/')
          const _path =
            lastIndex == 3
              ? `${_location.pathname}cookiePolicy`
              : `${_location.pathname}/cookiePolicy`
          const _pathname = _location.pathname === '/' ? '' : _path
          const url = `${_location.origin}${_pathname}`
          jumpToPage(url, 'open', '_blank')
          return
        } else {
          this.$router_push({
            path: `/cookiePolicy`,
          })
        }
      },
    },
  }
</script>

<style scoped lang="scss">
  .cookies-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px 0;
    color: #999;
    &.light {
      color: #fff;
    }

    .cookies-text {
      font-size: 30px;
    }
    .line {
      margin: 0 16px;
    }
    &.defaultColor {
      color: #fff;
      opacity: 0.9;
    }
  }
</style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    .cookies-footer {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px 0;
      color: #999;
      &.light {
        color: #fff;
      }
      &.details {
        color: hsla(0, 0%, 100%, 0.6);
        .cookies-text,
        .line {
          font-size: 14px;
          font-family: Roboto-Medium, Roboto;
          font-weight: 400;
        }
      }
      .cookies-text {
        font-size: 12px;
        cursor: pointer;
      }
      .line {
        margin: 0 5px;
      }
    }
  }
</style>
